<template>
  <v-app>
    <v-app-bar app color="dark" dark>
      <v-toolbar-title>Graph Labeling Study</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8">
            <v-card class="pa-8 text-center">
              <v-icon size="64" color="success">mdi-check-circle</v-icon>
              <h2 class="text-h4 mt-4 mb-4">Study Complete, Thank You!</h2>

              <p class="text-caption grey--text mt-4">
                <a :href="prolificUrl">
                  If you are not redirected, return to Prolific to complete your submission.
                </a>
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';
import prolificConfig from '@/config/prolific';

export default {
  name: 'ProlificFinish',
  title: 'Study Complete',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      prolificUrl: prolificConfig.PROLIFIC_COMPLETION_URL,
    };
  },
  created() {
    // Redirect timer runs independently of the /finish/ call below so a slow
    // or hung backend response can never delay or block the auto-redirect.
    setTimeout(() => {
      window.location.href = this.prolificUrl;
    }, 1500);

    fetch(
      `${config.API_BASE_URL}/prolific/session/${this.sessionId}/finish/`,
      { method: 'POST', headers: { 'Content-Type': 'application/json' } }
    )
      .then(resp => resp.json())
      .then(data => {
        if (data.prolific_completion_url) {
          this.prolificUrl = data.prolific_completion_url;
        }
      })
      .catch(e => console.error(e));
  },
};
</script>
